/* ============================================================
   Q-375 Compre junto: comportamento do combo (drawer + PDP)
   - Adicionar: POST /cart/add.js com items[] e property _sk_origin
     (combo_drawer | combo_pdp); só adiciona o que ainda não está no
     carrinho (jogo digital nunca vai com quantidade 2).
   - Eventos CUSTOM no dataLayer: combo_view e combo_add.
     event_id estável = combo_<sku>_<partner_sku>_<superfície>_<cart token ou sessão>,
     guard em sessionStorage por event_id (F5 / reabrir drawer não repete).
   - NÃO emite add_to_cart. O corpo items[] não é lido pelo interceptador do
     seekkey-datalayer.js (ele só lê body.id), então o add do combo NÃO gera
     add_to_cart no GTM; ver relatório da Q-375.
   ============================================================ */
(function () {
  'use strict';
  if (window.__skComboInit) return;
  window.__skComboInit = true;

  var mem = {};
  var cartToken = null;

  function sid() {
    try {
      var s = sessionStorage.getItem('sk_combo_sid');
      if (!s) {
        s = 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
        sessionStorage.setItem('sk_combo_sid', s);
      }
      return s;
    } catch (e) { return 'nosession'; }
  }

  function once(key) {
    try {
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, '1');
      return true;
    } catch (e) {
      if (mem[key]) return false;
      mem[key] = 1;
      return true;
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (c && c.token) cartToken = String(c.token).split('?')[0];
        return c;
      });
  }

  function eventId(el) {
    /* superfície no id: PDP e drawer contam separado (e o guard também) */
    return 'combo_' + (el.dataset.sku || '') + '_' + (el.dataset.partnerSku || '') + '_' + (el.dataset.surface || '') + '_' + (cartToken || sid());
  }

  function push(name, el) {
    var id = eventId(el);
    if (!once('sk_' + name + '_' + id)) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      event_id: id,
      combo_surface: el.dataset.surface,
      item_sku: el.dataset.sku,
      partner_sku: el.dataset.partnerSku,
      combo_discount_pct: Number(el.dataset.pct) || 0,
      combo_discount: (Number(el.dataset.discount) || 0) / 100,
      combo_value: (Number(el.dataset.value) || 0) / 100,
      currency: 'BRL'
    });
  }

  /* combo_view: só quando a pessoa pode ver a oferta.
     PDP: 50% do bloco na tela. Drawer: painel aberto com a oferta dentro. */
  function viewWhenReady(el) {
    if (el.__skSeen) return;
    el.__skSeen = true;
    (cartToken ? Promise.resolve() : fetchCart().catch(function () {}))
      .then(function () { push('combo_view', el); });
  }

  function watchPdp() {
    var blocks = document.querySelectorAll('[data-sk-combo][data-surface="pdp"]');
    if (!blocks.length) return;
    if (!('IntersectionObserver' in window)) { blocks.forEach(viewWhenReady); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); viewWhenReady(e.target); }
      });
    }, { threshold: 0.5 });
    blocks.forEach(function (b) { io.observe(b); });
  }

  function checkDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return;
    var el = drawer.querySelector('[data-sk-combo][data-surface="drawer"]');
    if (el) viewWhenReady(el);
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(checkDrawer, 120);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    checkDrawer();
  }

  /* Mesmo contrato do CartDrawer.renderContents (cart-drawer.js), sem o toast
     do mobile: o combo é uma escolha explícita, então o drawer abre. */
  function renderDrawer(sections) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !sections) return false;
    var targets = [
      { id: 'cart-drawer', el: document.getElementById('CartDrawer'), sel: '#CartDrawer' },
      { id: 'cart-icon-bubble', el: document.getElementById('cart-icon-bubble'), sel: '.shopify-section' }
    ];
    targets.forEach(function (t) {
      if (!t.el || !sections[t.id]) return;
      /* HTML do Section Rendering API: gerado pela Shopify, não é input de usuário */
      var doc = new DOMParser().parseFromString(sections[t.id], 'text/html');
      var src = doc.querySelector(t.sel);
      if (!src) return;
      t.el.replaceChildren();
      while (src.firstChild) t.el.appendChild(src.firstChild);
    });
    drawer.classList.remove('is-empty');
    var items = drawer.querySelector('cart-drawer-items');
    if (items) items.classList.remove('is-empty');
    return true;
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) {
      drawer.open(document.querySelector('#cart-icon-bubble') || undefined);
    }
    setTimeout(checkDrawer, 200);
  }

  function setBusy(btn, busy) {
    var label = btn.querySelector('[data-sk-combo-label]');
    if (busy) {
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      if (label) { label.dataset.orig = label.textContent; label.textContent = 'Adicionando...'; }
    } else {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      if (label && label.dataset.orig) label.textContent = label.dataset.orig;
    }
  }

  function showError(root, msg) {
    var err = root.querySelector('[data-sk-combo-err]');
    if (err) err.textContent = msg || '';
  }

  function add(btn) {
    var root = btn.closest('[data-sk-combo]');
    if (!root || btn.disabled) return;
    var ids = String(root.dataset.addIds || '').split(',').filter(Boolean);
    var origin = root.dataset.origin === 'combo_pdp' ? 'combo_pdp' : 'combo_drawer';
    if (!ids.length) return;
    setBusy(btn, true);
    showError(root, '');

    fetchCart()
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var inCart = (cart.items || []).map(function (i) { return String(i.variant_id); });
        var toAdd = ids.filter(function (id) { return inCart.indexOf(id) === -1; });
        if (!toAdd.length) return { already: true };
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: toAdd.map(function (id) {
              return { id: Number(id), quantity: 1, properties: { _sk_origin: origin } };
            }),
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        }).then(function (r) { return r.json(); });
      })
      .then(function (resp) {
        if (resp && resp.status) throw new Error('cart_add_' + resp.status);
        if (!resp.already) push('combo_add', root);
        if (resp.sections) renderDrawer(resp.sections);
        else if (resp.already) return refreshDrawer();
      })
      .then(function () {
        setBusy(btn, false);
        openDrawer();
      })
      .catch(function () {
        setBusy(btn, false);
        showError(root, 'Não foi possível adicionar agora. Tente de novo.');
      });
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(renderDrawer)
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sk-combo-add]');
    if (!btn) return;
    e.preventDefault();
    add(btn);
  });

  function init() { watchPdp(); watchDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
